/* 
 	* 指令下发组件 
 	* 描述：InsOCARObd指令下发
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
     	<form class="form-horizontal pt10px">
     		<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>指令参数</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" v-model="parameters">
					<span class="dis_block pt5px orange_t">0:关 1：开</span>
			    </div>	
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			 <div class="form-group text-right pt10px pr10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>	
    </div>	
</template>
<script>
	export default {
		name: "InsOCARObd",
		data() {
			return {
				parameters :"",            //指令参数
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.parameters = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				let r1=/^(0{1}|1{1})$/.test(this.parameters)
				if(!r1){
					this.alertMsg='指令参数必须为1或0';
					return;
				}else{
					this.alertMsg='';
				}
				let arr = ["SETPRM","0000F007",this.parameters]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
				
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsOCARObd.vue?57a0c9bb